import React from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import { Td, Th, Tr, Thead } from '../ratePlans/components/css';
import SectionHeading from '../sectionHeading';
import getFormattedPricing from '../utils';
import { getRateplanTotalQuantity, DELIVERY_CHARGE } from '../ratePlans/util';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const DeliveryCharges = ({ ratePlans, productSelected }) => {
  const {
    contentfulValues: {
      valueNorthStarSystems,
      valueNorthStarSystemsFarmAndRanch
    },
    iotOrderDetailsSection: {
      labelDeliveryCharges,
      labelHeaderDeliveryChargesUnits,
      labelHeaderDescription,
      labelHeaderUnits,
      labelHeaderTotal,
      labelFlatRateDeliveryCharge,
      labelIncludedDeliveryCharge
    }
  } = useLocalizedStringsContext();

  const totalRateplanUnits = getRateplanTotalQuantity(ratePlans);

  const getDescriptionLabel = () => {
    if (productSelected === valueNorthStarSystems)
      return labelFlatRateDeliveryCharge;
    if (productSelected === valueNorthStarSystemsFarmAndRanch)
      return labelIncludedDeliveryCharge;
    return '';
  };

  const getDeliveryCharges = () => {
    if (productSelected === valueNorthStarSystems) return DELIVERY_CHARGE;
    if (productSelected === valueNorthStarSystemsFarmAndRanch) return 0;
    return 0;
  };

  return (
    <StackView space={3}>
      <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{labelDeliveryCharges}</Typography></SectionHeading>
      <table>
        <Thead>
          <Tr>
            <Th>{labelHeaderDeliveryChargesUnits}</Th>
            <Th>{labelHeaderDescription}</Th>
            <Th>{labelHeaderUnits}</Th>
            <Th>{labelHeaderTotal}</Th>
          </Tr>
        </Thead>
        <tbody>
          <Tr>
            <Td>{getFormattedPricing(getDeliveryCharges())}</Td>
            <Td>{getDescriptionLabel()}</Td>
            <Td>{totalRateplanUnits}</Td>
            <Td>
              {getFormattedPricing(totalRateplanUnits * getDeliveryCharges())}
            </Td>
          </Tr>
        </tbody>
      </table>
    </StackView>
  );
};

DeliveryCharges.propTypes = {
  ratePlans: PropTypes.shape({}).isRequired,
  productSelected: PropTypes.string.isRequired
};

export default DeliveryCharges;
